export default "__VITE_ASSET__CCG4XwoB__";